import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { Schedule } = protos;

export function resolveDates(schedule: core.ISchedule) {
  const request = Schedule.fromObject(schedule);
  return {
    TockApi: {
      postProto: '/schedule/resolve',
      request,
      type: AppConstants.RESOLVE_SCHEDULE_DATES,
    },
  };
}
